import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-redirect',
    template: `<p>Redirigiendo...</p>`
})
export class RedirectComponent implements OnInit {

    constructor(private route: ActivatedRoute, private router: Router) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            const redirectUrl = params['redirect'];

            if (redirectUrl) {
                const decodedUrl = decodeURIComponent(redirectUrl);
                console.log('🔄 Redirigiendo a:', decodedUrl);
                
                // 🔥 Pequeño retraso para evitar conflictos de carga
                setTimeout(() => {
                    this.router.navigateByUrl(decodedUrl);
                }, 100);
            } else {
                this.router.navigate(['/apps/dashboards/resumen']);
            }
        });
    }
}
